import { API_V1 } from "../config/main-axios";

class Course {
    getAllCourses(data) {
        return API_V1.get(`/courses/performing/admin/courses/`, {
            params: data
        })
    }

    getAllCategory(data) {
        return API_V1.get(`/courses/base/admin/course_category/`, {
            params: data
        })
    }

    getCategoryExcel() {
        return API_V1.get(`/courses/base/admin/course_category/export_to_excel/`, {
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
                // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
            },
            responseType: 'blob'
        })
    }

    addNewCategory(data) {
        return API_V1.post(`/courses/base/admin/course_category/`, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    }

    editCategory(params) {
        return API_V1.patch(`/courses/base/admin/course_category/${params.id}/`, params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    }

    deleteCategory(id) {
        return API_V1.delete(`/courses/base/admin/course_category/${id}/`)
    }

    archiveCategory(data) {
        // return API_V1.patch(`/courses/base/admin/course_category/${params.id}/`, {is_shown: !params.is_shown})
        return API_V1.put(`/courses/base/admin/course_category/update_archive/`, data)
    }

    multipleStatusActionOnCategory(data) {
        return API_V1.patch(`/courses/base/admin/course_category/multiple_active/`, data)
    }
    updateReturnCourses(data) {
        return API_V1.put(`/courses/base/admin/base_courses/update_archive/`, data)
    }
    updateReturnPerformingCourses(data) {
        return API_V1.put(`/courses/performing/admin/courses/update_archive/`, data)
    }

    singleStatusActionOnCategory(params) {
        return API_V1.patch(`/courses/base/admin/course_category/${params.id}/`, { is_active: !params.is_active })
    }

    getAllBaseCourse(data) {
        return API_V1.get(`/courses/base/admin/base_course/`, {
            params: data
        })
    }

    getStagingGroups(data) {
        return API_V1.get(`/courses/base/admin/staging-groups/`, {
            params: data
        })
    }

    createStagingGroup(data) {
        return API_V1.post(`/courses/base/admin/staging-groups/`, data)
    }

    getBaseCourseById(id) {
        return API_V1.get(`/courses/base/admin/base_course/${id}/`)
    }

    multipleStatusActionOnBaseCourse(data) {
        return API_V1.patch(`/courses/base/admin/base_course/multiple_active/`, data)
    }

    singleStatusActionOnBaseCourse(data) {
        return API_V1.patch(`/courses/base/admin/base_course/${data.id}/`, data)
    }

    addStepToCourse(data, configs) {
        return API_V1.post(`/courses/base/admin/base_course/`, data, configs)
    }

    editStepCourse({ data, id }, configs) {
        return API_V1.patch(`/courses/base/admin/base_course/${id}/`, data, configs)
    }

    archiveBaseCourse(params) {
        return API_V1.patch(`/courses/base/admin/base_course/${params.id}/`, { is_archive: true })
    }

    getLessons(data) {
        return API_V1.get(`/courses/base/admin/lesson/`, {
            params: data
        })
    }

    addLessons(data) {
        return API_V1.post(`/courses/base/admin/lesson/`, data)
    }

    editLessons(data) {
        return API_V1.patch(`/courses/base/admin/lesson/${data.id}/`, data)
    }

    deleteLessons(id) {
        return API_V1.delete(`/courses/base/admin/lesson/${id}/`)
    }

    getSessions(data) {
        return API_V1.get(`/courses/base/admin/session/`, {
            params: data
        })
    }

    postSessions(data) {
        return API_V1.post(`/courses/base/admin/session/`, data)
    }
    patchSessions(data) {
        return API_V1.patch(`/courses/base/admin/session/${data.id}/`, data)
    }

    getAllClasses(data) {
        return API_V1.get(`courses/performing/admin/courses/`, {
            params: data
        })
    }

    multipleStatusActionOnClasses(data) {
        return API_V1.patch(`/courses/performing/admin/courses/multiple_active/`, data)
    }

    singleStatusActionOnClass(params) {
        return API_V1.patch(`/courses/performing/admin/courses/${params.id}/`, { is_active: !params.is_active })
    }

    archiveClass(params) {
        return API_V1.patch(`courses/performing/admin/courses/${params.id}/`, { is_archive: true })
    }









    createClass(data, configs) {
        return API_V1.post("/courses/performing/admin/courses/", data, configs)
    }
    updateClass(id, data, configs) {
        return API_V1.patch(`/courses/performing/admin/courses/${id}/`, data, configs)
    }
    deleteClassLessons(id) {
        return API_V1.delete(`/courses/performing/admin/courses/${id}/`)
    }
    getClassById(id) {
        return API_V1.get(`/courses/performing/admin/courses/${id}/`)
    }
    getSubCourseLesson(data) {
        return API_V1.get("/courses/performing/admin/lessons/", { params: data })
    }
    updateSubCourseLesson(data) {
        return API_V1.patch(`/courses/performing/admin/lessons/${data.id}/`, data)
    }
    createSubCourseLesson(data) {
        return API_V1.post(`/courses/performing/admin/lessons/`, data)
    }
    getSessionListOnClass(data) {
        return API_V1.get(`/courses/performing/admin/sessions/`, {
            params: data
        })
    }
    getSessionByIdOnClass(id) {
        return API_V1.get(`/courses/performing/admin/sessions/${id}/`)
    }
    createSessionByIdOnClass(data) {
        return API_V1.post(`/courses/performing/admin/sessions/`, data)
    }
    updateSessionByIdOnClass(data) {
        return API_V1.patch(`/courses/performing/admin/sessions/${data.id}/`, data)
    }
    getOnlineSessions(data) {
        return API_V1.get(`/courses/performing/admin/sessions/`, {
            params: data
        })
    }
    updateOnlineLesson(data) {
        return API_V1.patch(`/courses/performing/admin/sessions/${data.id}/`, data)
    }
    getClassExcel(data) {
        return API_V1.get(`/courses/performing/admin/courses/export_to_excel/`, {
            params: data,
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
                // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
            },
            responseType: 'blob'
        })
    }
    getExcel(data) {
        return API_V1.get(`/courses/base/admin/base_course/export_to_excel/`,
            {
                params: data,
                headers: {
                    "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
                    // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
                },
                responseType: 'blob'
            })
    }
    getClassStudents(id, data) {
        return API_V1.get(`/courses/performing/admin/courses/${id}/students/`, {
            params: data
        })
    }
    addClassStudents(id, data) {
        return API_V1.post(`/courses/performing/admin/courses/${id}/add_user_register_courses/`, data)
    }
    deleteUserFromCourses(id, data) {
        return API_V1.delete(`/courses/performing/admin/courses/${id}/delete_user_register_courses/`, {
            data: {
                user_ids: data
            },
        })
    }

    getNotStudentRegister(id, data) {
        return API_V1.get(`/courses/performing/admin/courses/${id}/get_not_student_register_courses/`, {
            params: data
        })
    }
    getForeignPaymentExcel(data) {
        return API_V1.get(`/reports/admin/users/foreign_payment_export_excel/`, {
            params: data,
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
                // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
            },
            responseType: 'blob'
        })
    }
    getPaymentExcel(data) {
        return API_V1.get(`/reports/admin/users/payment_export_excel/`, {
            params: data,
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
                // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
            },
            responseType: 'blob'
        })
    }
    getStudentsClassExcel(id, data) {
        return API_V1.get(`/reports/admin/users/${id}/students/`, {
            params: data,
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
                // Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
            },
            responseType: 'blob'
        })
    }
}


export default new Course();
